import type { ReactNode } from "react";
import "./StatusNarration.scss";

function DocIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="7" width="16" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <line x1="12" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="12" y1="16" x2="20" y2="16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="12" y1="20" x2="16" y2="20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
}

export default function StatusNarration({ children }: { children: ReactNode }) {
    return (
        <div className="StatusNarration">
            <div className="IconHolder">
                <div className="Icon">
                    <DocIcon />
                </div>
            </div>
            <div className="TextHolder">
                <p className="Text">{children}</p>
            </div>
        </div>
    );
}
